import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

const useSortOptions = () => {
  const { t } = useTranslation('projects');

  return useMemo(
    () => [
      {
        label: t('createdOn'),
        value: 'createdOn',
      },
      {
        label: t('createdBy'),
        value: 'createdBy',
      },
    ],
    [t],
  );
};

export default useSortOptions;
